import React, {Component} from 'react';
import Compose from './Compose';
import MailList from './MailList';
import Message from './Message';

// import './mail-box.css';

class TestPage extends Component {
    constructor() {
        super();

        this.state = {
            isComposeMode: true,
            isMailListMode: false,
            isMessageMode: false,
            allEmailMessages: [],
            messageInfo: {}
        }
    }

    setAllEmailMessages(allEmailMessages) {
        if (allEmailMessages != null && allEmailMessages.length > 0) {
            this.setState({allEmailMessages});
        }
    }

    messageDetails(messageInfo) {
        if (messageInfo != (undefined || null)) {
            this.setState({messageInfo, isMessageMode: true});
        }
    }


    render() {
        return (
            <div className="content">
                <div className="row">
                    <div className="col-md-12">
                        <h2 className="page-title">Inbox
                            <small>Ready-to-use client-side application</small>
                        </h2>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <section className="widget">

                            <h4>
                                Inbox App
                            </h4>

                            <div className="body">
                                <div id="mailbox-app" className="mailbox">
                                    <div className="row">
                                        <div className="col-sm-2">
                                            <button id="compose-btn" className="btn btn-danger btn-block"
                                                    onClick={() => {
                                                        this.setState({
                                                            isComposeMode: true,
                                                            isMailListMode: false,
                                                            isMessageMode: false
                                                        })
                                                    }}>Compose
                                            </button>
                                            <ul id="folders-list" className="mailbox-folders">
                                                <li className="active">
                                                    <a onClick={() => {
                                                        this.setState({
                                                            isComposeMode: false,
                                                            isMailListMode: true,
                                                            isMessageMode: false
                                                        })
                                                    }}>Inbox</a>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="col-sm-10">
                                            <h2 id="folder-title" className="folder-title">Inbox
                                                <small>(2 unread messages)</small>
                                            </h2>

                                            {(this.state.isComposeMode && !this.state.isMailListMode && !this.state.isMessageMode) ?
                                                <Compose/> : (!this.state.isComposeMode && this.state.isMailListMode && !this.state.isMessageMode) ?
                                                    <MailList allEmailMessages={this.state.allEmailMessages}
                                                              setAllEmailMessages={this.setAllEmailMessages.bind(this)}
                                                              messageDetails={this.messageDetails.bind(this)}
                                                    /> :
                                                    <Message messageInfo={this.state.messageInfo}/>}


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        )
    }
}

export default TestPage;



// WEBPACK FOOTER //
// ./src/views/TestPage/TestPage.js